import { request } from '../../scripts/utils'
export const getPlanListService = () => {
  return request(
    'portal/plan/goods',
    {
      page: 1,
      size: 1000
    },
    true,
    'GET'
  )
}

export const sumbitOrderService = data => {
  return request('portal/order', data, true, 'PUT')
}

export const getOrderListService = data => {
  return request('portal/orders', data, true, 'GET')
}

export const getGoodsDetailService = id => {
  return request(`portal/plan/goods/${id}`, null, true, 'GET')
}

// 获取订单详情
export const getOrderDetailService = id => {
  return request(`portal/orders/${id}`, null, true, 'GET')
}

// 获取订单列表（分页、筛选）
export const getOrdersService = params => {
  return request('portal/orders', params, true, 'GET')
}

// 获取订单状态数量统计
export const getOrdersBriefService = () => {
  return request('portal/orders/brief', null, true, 'GET')
}

// 取消订单
export const cancelOrderService = id => {
  return request(`portal/orders/${id}/cancel`, null, true, 'POST')
}

export const getCreditCardsService = params => {
  return request('portal/cards', params, true, 'GET')
}

// Setup Intents - 在添加信用卡之前调用
export const setupIntentsService = () => {
  return request('portal/setupIntents', null, true, 'PUT')
}

export const addCreditCardService = (paymentMethodId, data) => {
  return request(`portal/cards/${paymentMethodId}`, data, true, 'PUT')
}

export const cardPaymentService = data => {
  return request('portal/order/card/payment', data, true, 'POST')
}

export const invoicePaymentService = data => {
  return request('portal/order/requestBook/payment', data, true, 'POST')
}

export const getCustomerInfoService = () => {
  return request('portal/customers', null, true, 'GET')
}

export const updateCustomerInfoService = data => {
  return request('portal/customers', data, true, 'POST')
}

export const addCustomerInfoService = data => {
  return request('portal/customers', data, true, 'PUT')
}

export const getCustomerDomainsService = async () => {
  try {
    const res = await request('portal/customer/domain', null, true, 'GET')
    if (res?.code === 200 && Array.isArray(res.data)) {
      return { success: true, data: res.data.map(item => ({ id: item.id, url: item.domain })) }
    }
    return { success: false }
  } catch (error) {
    return { success: false }
  }
}

export const addCustomerDomainService = async data => {
  try {
    const res = await request(
      'portal/customer/domain',
      { str: data?.url },
      true,
      'PUT'
    )
    if (res?.code === 200) {
      return { success: true }
    }
    return { success: false, code: res.code }
  } catch (error) {
    return { success: false }
  }
}

export const removeCustomerDomainService = async data => {
  try {
    const res = await request(`portal/customer/domain/${data?.id}`, data, true, 'DELETE')
    if (res?.code === 200) {
      return { success: true }
    }
    return { success: false }
  } catch (error) {
    return { success: false }
  }
}

export const updateCustomerDomainService = async data => {
  try {
    const res = await request(
      `portal/customer/domain/${data?.id}`,
      { str: data?.url },
      true,
      'POST'
    )
    if (res?.code === 200) {
      return { success: true }
    }
    return { success: false, code: res.code }
  } catch (error) {
    return { success: false }
  }
}

export const expandSeatService = data => {
  return request('portal/order/expand', data, true, 'POST')
}

// 下载发票
export const downloadInvoiceService = id => {
  return request(`portal/orders/${id}/invoices`, null, true, 'GET', true)
}

// 下载请求书
export const downloadRequestBookService = id => {
  return request(`portal/orders/${id}/requestBook`, null, true, 'GET', true)
}

// 获取订单信用卡信息
export const getOrderCardInfoService = id => {
  return request(`portal/orders/${id}/card`, null, true, 'GET')
}

// 获取套餐信息
export const getCustomerPlanService = () => {
  return request('portal/customers/plan', null, true, 'GET')
}

// 获取席位和模型信息
export const getSeatAndModelService = () => {
  return request('portal/members/seatAndModel', null, true, 'GET')
}

// 获取信用卡续费信息
export const getRenewalFailuresService = () => {
  return request('portal/customers/plan/renewal-failures', null, true, 'GET')
}

// 获取成员列表
export const getMembersService = data => {
  return request('portal/members', data, true, 'GET')
}

// 添加成员
export const addMemberService = data => {
  return request('portal/members', data, true, 'PUT')
}

// 修改成员角色
export const changeMemberRoleService = data => {
  return request('portal/members/changeRole', data, true, 'POST')
}

// 更新成员席位占用
export const updateMemberSeatService = data => {
  return request('portal/members/useSeat', data, true, 'POST')
}

// 启用 / 禁用成员
export const enableMemberService = userId => {
  return request(`portal/members/${userId}/enable`, null, true, 'POST')
}

export const disableMemberService = userId => {
  return request(`portal/members/${userId}/disable`, null, true, 'POST')
}

// 批量添加成员
export const batchAddMembersService = formData => {
  return request('portal/members/import', formData, true, 'POST')
}

// 移除成员
export const removeMemberService = id => {
  return request(`portal/members/${id}`, null, true, 'DELETE')
}

// 批量移除成员
export const batchRemoveMembersService = data => {
  return request('portal/members', data, true, 'DELETE')
}

// 激活成员
export const activeMemberService = id => {
  return request(`portal/members/${id}/active`, null, true, 'PUT')
}

// 编辑成员
export const updateMemberService = (id, data) => {
  return request(`portal/members/${id}`, data, true, 'POST')
}

// 导出成员列表
export const exportMembersService = params => {
  return request('portal/members/export', params, true, 'GET', true)
}

// 设置管理员权限
export const setAdminService = id => {
  return request(`portal/members/${id}/admin`, null, true, 'PUT')
}

// 取消管理员权限
export const cancelAdminService = id => {
  return request(`portal/members/${id}/admin`, null, true, 'DELETE')
}

// 下载批量导入模板
export const downloadMemberTemplateService = () => {
  return request('portal/members/import/template', null, true, 'GET', true)
}

// 更新默认信用卡
export const updateDefaultCardService = paymentMethodId => {
  return request(`portal/cards/${paymentMethodId}/default`, null, true, 'POST')
}

// 获取请求书付款信息
export const getFundingInstructionsService = () => {
  return request('portal/customers/fundingInstructions', null, true, 'GET')
}

// 再次发送请求书
export const resendInvoiceService = data => {
  return request('portal/order/requestBook', data, true, 'POST')
}

// 根据邮编获取地址
export const getAddressByPostalCodeService = postalCode => {
  return request(
    `portal/postalCode/address?postalCode=${postalCode}`,
    null,
    true,
    'GET',
    false
  )
}

// 获取账号取消信息
export const getCustomerPlanCancelInfoService = () => {
  return request('portal/customers/plan/cancel', null, true, 'GET')
}
